<template>
  <v-app style="width: 100vw; overflow-x: hidden;">
    <v-app-bar app color="rgba(255,255,255,1)" height="80px" class="pa-0 ma-0" clipped-left>
      <v-avatar tile size="80px" style="margin-left: -15px;">
        <v-img src="./assets/BogenRot.png"></v-img>
      </v-avatar>
      <v-toolbar-title class="text-uppercase font-weight-bold">
        <span class="font-weight-regular">Dental Design </span>Jörg Seidel
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        @click="menu=!menu"
        icon
        x-large
        style="margin-left: -10px;"
        v-if="$vuetify.breakpoint.mdAndDown"
      >
        <v-icon v-if="!menu">mdi-menu</v-icon>
        <v-icon v-if="menu">mdi-close</v-icon>
      </v-btn>
      <v-btn text v-if="$vuetify.breakpoint.lgAndUp" @click="$vuetify.goTo(0, {duration: 800, offset: 0, easing: 'easeInOutQuad'}); menu = false;">START</v-btn>
      <v-btn text v-if="$vuetify.breakpoint.lgAndUp" @click="$vuetify.goTo('#wir-designen', {duration: 800, easing: 'easeInOutQuad'}); menu = false;">WIR DESIGNEN</v-btn>
      <v-btn text v-if="$vuetify.breakpoint.lgAndUp" @click="$vuetify.goTo('#unser-service', {duration: 800, easing: 'easeInOutQuad'}); menu = false;">UNSER SERVICE</v-btn>
      <v-btn text v-if="$vuetify.breakpoint.lgAndUp" @click="$vuetify.goTo('#unser-labor', {duration: 800, easing: 'easeInOutQuad'}); menu = false;">UNSER LABOR</v-btn>
      <v-btn text v-if="$vuetify.breakpoint.lgAndUp" @click="$vuetify.goTo('#unser-team', {duration: 800, easing: 'easeInOutQuad'}); menu = false;">UNSER TEAM</v-btn>
      <v-btn text v-if="$vuetify.breakpoint.lgAndUp" @click="$vuetify.goTo('#kontakt', {duration: 800, easing: 'easeInOutQuad'}); menu = false;">KONTAKT</v-btn>
    </v-app-bar>
    <v-app-bar
      v-if="false"
      app
      inverted-scroll
      color="primary"
      class="elevation-0"
      :scroll-threshold="windowHeight/3"
      dark
    >
      <h1 class="text-uppercase font-weight-regular">Dental Design</h1>
      <v-avatar tile class="mx-2">
        <v-img src="./assets/icon.png"></v-img>
      </v-avatar>
      <h1 class="text-uppercase">Jörg Seidel</h1>
      <v-spacer></v-spacer>
      <v-btn @click="menu=!menu" icon x-large>
        <v-icon v-if="!menu">mdi-menu</v-icon>
        <v-icon v-if="menu">mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer v-model="menu" color="light-green" app dark temporary>
      <v-list nav>
        <v-list-item
          link
          large
          @click="$vuetify.goTo(0, {duration: 800, offset: 0, easing: 'easeInOutQuad'}); menu = false;"
        >
          <v-list-item-content>
            <v-list-item-title>START</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          large
          @click="$vuetify.goTo('#wir-designen', {duration: 800, easing: 'easeInOutQuad'}); menu = false;"
        >
          <v-list-item-content>
            <v-list-item-title>WIR DESIGNEN</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          large
          @click="$vuetify.goTo('#unser-service', {duration: 800, easing: 'easeInOutQuad'}); menu = false;"
        >
          <v-list-item-content>
            <v-list-item-title>UNSER SERVICE</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          large
          @click="$vuetify.goTo('#unser-labor', {duration: 800, easing: 'easeInOutQuad'}); menu = false;"
        >
          <v-list-item-content>
            <v-list-item-title>UNSER LABOR</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          large
          @click="$vuetify.goTo('#unser-team', {duration: 800, easing: 'easeInOutQuad'}); menu = false;"
        >
          <v-list-item-content>
            <v-list-item-title>UNSER TEAM</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          large
          @click="$vuetify.goTo('#kontakt', {duration: 800, easing: 'easeInOutQuad'}); menu = false;"
        >
          <v-list-item-content>
            <v-list-item-title>KONTAKT</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="pa-0" style="width: 100vw;">
      <Start />
    </v-main>
    <v-speed-dial
      fixed
      v-model="fab"
      bottom
      right
      direction="top"
      open-on-hover
      transition="slide-y-reverse-transition"
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          :color="fab ? 'grey' : 'red darken-2'"
          dark
          fab
          large
        >
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-phone</v-icon>
        </v-btn>
      </template>
      <v-btn
        color="red"
        dark
        fab
        x-large
        href="tel:025751640"
      >
        <v-icon>mdi-phone</v-icon>
      </v-btn>
      <v-btn
        dark
        x-large
        fab
        color="green"
        href="mailto: dentallabor-seidel@t-online.de"
      >
        <v-icon>mdi-email</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-footer padless>
      <v-card flat tile width="100%" class="grey darken-4 text-center">
        <v-card-text>
          <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-2" text dark v-bind="attrs" v-on="on">Impressum</v-btn>
            </template>
            <v-card>
              <v-toolbar dark color="light-green">
                <v-btn icon dark @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Impressum</v-toolbar-title>
              </v-toolbar>
              <Impressum></Impressum>
            </v-card>
          </v-dialog>
          
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="white--text">
          <v-icon dark class="mr-2">mdi-copyright</v-icon>
          {{ new Date().getFullYear() }} —
          <strong>Dental Design Jörg Seidel</strong>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-btn class="mx-2" text dark x-small>Webdesign by Tim Vallandi</v-btn>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import Start from "./components/index";
import Impressum from "./components/impressum";

export default {
  name: "App",

  components: {
    Start,
    Impressum
  },

  data: () => ({
    menu: false,
    dialog: false,
    fab: false,
    windowHeight: window.innerHeight,
  }),
};
</script>

<style>
*::-webkit-scrollbar {
  display: none;
}
</style>